module.exports = __webpack_public_path__ + "img/faq.f12a47cb.jpg";